import { Modal, Stack, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";

import {
  ModalContentContainer,
  ModalHeaderContainer
} from "../duplicate/DuplicateSiteModal";
import RequestNewConfiguration from "./RequestNewConfiguration";
import { basicColours } from "../../lib/colors";
import { clearSiteOperationTempData } from "../site/siteSlice";
import { useAppDispatch } from "../../store";
import { getSiteOperationTempData } from "../../redux/selectors/siteSelectors";
import { useSelector } from "react-redux";
import { LoadingSpinner } from "../site/ConfigurationItems";
import { getSelectedDrawersData } from "../../redux/selectors/drawerSelectors";
import { useGetSiteConfigurationsListQuery } from "../../redux/api/site";
import TemporaryNewConfigurationData from "./TemporaryNewConfigurationData";

type AddNewConfigurationModalContentProps = {
  onClose: () => void;
  isOpen: boolean;
};

const AddNewConfigurationModal = (
  props: AddNewConfigurationModalContentProps
) => {
  const dispatch = useAppDispatch();
  const { onClose, isOpen } = props;

  const siteOperationData = useSelector(getSiteOperationTempData);
  const {
    configurationType: configurationTypeToCopyFrom,
    newRequestedConfiguration
  } = siteOperationData.requestNewSiteConfigurationTempData;

  const selectedDrawersData = useSelector(getSelectedDrawersData);
  const siteId = selectedDrawersData.site?.id;
  const { data: currentSiteConfigurations } = useGetSiteConfigurationsListQuery(
    siteId
      ? {
          siteId
        }
      : skipToken
  );
  const handleOnClose = () => {
    dispatch(clearSiteOperationTempData({ shouldHardReset: false }));
    onClose();
  };
  const shouldRenderNewConfiguration =
    !!newRequestedConfiguration &&
    !!currentSiteConfigurations?.allConfigurationsMenuTypes;

  return (
    <Modal
      open={isOpen}
      onClose={handleOnClose}
      aria-labelledby="select-configuration-to-copy-from-modal-title"
      role="dialog"
      disableEscapeKeyDown
      sx={{
        height: shouldRenderNewConfiguration ? "95%" : "500px",
        top: shouldRenderNewConfiguration ? "0%" : "15%"
      }}
    >
      <ModalContentContainer
        sx={{
          minWidth: 400,
          maxWidth: 500,
          height: "auto",
          minHeight: 300,
          ...(shouldRenderNewConfiguration && {
            minWidth: 600,
            maxWidth: 1500,
            width: "90%",
            height: "inherit",
            minHeight: "80%"
          })
        }}
      >
        <ModalHeaderContainer sx={{ minHeight: 50 }}>
          <Typography
            id="select-configuration-to-copy-from-modal-title"
            variant="h6"
            textAlign="center"
            color={basicColours.mono.white}
          >
            {configurationTypeToCopyFrom.id && !shouldRenderNewConfiguration ? (
              <>
                {configurationTypeToCopyFrom.name} <br />
                configuration creation
              </>
            ) : (
              "Add New Configuration"
            )}
          </Typography>
        </ModalHeaderContainer>

        {!configurationTypeToCopyFrom.id && !newRequestedConfiguration ? (
          <LoadingSpinner />
        ) : (
          <>
            {configurationTypeToCopyFrom && !newRequestedConfiguration && (
              <Stack
                flex={1}
                flexDirection="row"
                justifyContent="center"
                height={"inherit"}
              >
                <RequestNewConfiguration onClose={handleOnClose} />
              </Stack>
            )}
            {shouldRenderNewConfiguration && (
              <TemporaryNewConfigurationData
                onClose={handleOnClose}
                currentSiteConfigurations={currentSiteConfigurations}
              />
            )}
          </>
        )}
      </ModalContentContainer>
    </Modal>
  );
};
export default AddNewConfigurationModal;
